<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
      
    <div class="dialog-content-container">
    <app-select-input [label]="'Title'" [control]="personForm.controls.title" [lookupItems]="titles" placeholder="Select a Title">
      </app-select-input>
   

    @if (personForm.controls.title.value?.value === 'Other') {

      <app-text-input label="Please specify title" [control]="personForm.controls.titleOther" shortLabel="Title">
      </app-text-input>

    }

    <app-text-input [label]="'Given Names'" [control]="personForm.controls.firstname" shortLabel="Given Names">
    </app-text-input>

    <app-text-input [label]="'Surname / Family Name'" shortLabel="Surname" [control]="personForm.controls.surname">
    </app-text-input>
 

      <app-date-input [label]="'Date of Birth'" [control]="personForm.controls.dob">
      </app-date-input>

   <app-select-input [label]="personRelationLabel"  [control]="personForm.controls.relationToApplicant"
        [lookupItems]="relationTypes" [errorMsg]="'Relation is required'" placeholder="Select a Relation">
      </app-select-input>

    @if(personType == 'nonIncludedChild') {
     <app-select-input [label]="passportCountryLabel"
        [control]="personForm.controls.countryofResidence" [lookupItems]="countries" placeholder="Select a Country">
      </app-select-input>
    }
    @else {
        <app-select-input [label]="passportCountryLabel"
            [control]="personForm.controls.passportCountry" [lookupItems]="countries" placeholder="Select a Country">
        </app-select-input>
    }

 @if(personType == 'otherFamilyMember') {
        <app-text-input [label]="'Passport Number'"
            [control]="personForm.controls.passportNumber">
        </app-text-input>
    
       
    @if(!isVevo){

        <app-select-input [label]="'Marital Status'"
            [control]="personForm.controls.maritalStatus" [lookupItems]="maritalStatuses" placeholder="Select a Marital Status">
        </app-select-input>

        <app-select-input [label]="'What is the highest level of education achieved by this family member?'"
            [control]="personForm.controls.education" shortLabel="Education" [lookupItems]="educationLevels" placeholder="Select a Education Level">
        </app-select-input>
        <app-text-input [label]="'What is the usual occupation of this family member?'"
            [control]="personForm.controls.occupation" shortLabel="Occupation">
        </app-text-input>
    }


    @if(!isVevo && ageDifference() >= 18) {

        <app-radio-input [label]="'Is this family member incapacitated for Work?'"
            [control]="personForm.controls.incapacitated" shortLabel="Incapacitated"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">

        </app-radio-input>
    }
   
        @if(!isVevo && (ageDifference() > 0 && ageDifference() < 18) && personForm.controls.relationToApplicant.value?.value !== 'spouse-partner') {
            
        <app-radio-input [label]="'Is this family member financially dependent on the applicant?'"
            [control]="personForm.controls.financialDependancy" 
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>
        }

    

    @if(!isVevo) {
            <app-radio-input [label]="'Is this family member currently located in Australia?'"
            [control]="personForm.controls.inAustralia" shortLabel="In Australia"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>
        
    }

    @if(personForm.controls.inAustralia.value === 'false' && !isVevo) {
        <app-select-input [label]="'Where is this family member currently located?'" shortLabel="Location"
            [control]="personForm.controls.location" [lookupItems]="countries" placeholder="Select a Country">
        </app-select-input>
    
    }
    @if(personForm.controls.inAustralia.value === 'true' && !isVevo) {
        <app-date-input [label]="'What date did this family member arrive in Australia?'" [control]="personForm.controls.arriveAustralia" shortLabel="Arrive Australia">
        </app-date-input>

        <app-date-input [label]="'What date is this family member required to depart Australia? (Leave blank if not applicable)'" [control]="personForm.controls.departAustralia" shortLabel="Depart Australia">
        </app-date-input>

                <app-radio-input [label]="'Does this family member have a current Australian Visa?'"
            [control]="personForm.controls.holdAustralianVisa" shortLabel="Hold Australian Visa"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
        </app-radio-input>


        @if(personForm.controls.holdAustralianVisa.value === 'true' && !isVevo) {
        <app-select-input [label]="'What type of Australian Visa does this family member hold?'" shortLabel="Visa Type"
            [control]="personForm.controls.visaType" [visaTypes]="visaTypes" placeholder="Select a Visa Type">
        </app-select-input>

        <app-date-input [label]="'When does this family members visa expire?'" [control]="personForm.controls.visaExpire">
        </app-date-input>

        }

    }
}

</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="close()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>